import { React, FelaComponent } from '../../dependencies';

import style from './Divider.style';

const Divider = () => <FelaComponent style={style} />;

export default Divider;
